import { z, ZodType } from 'zod';

export type Wallet = {
	id: number;
	balance: number | null;
	currency: string;
	numberOfBets: number;
	turnover: number;
	cashdeskProfit: number;
	isLocked: boolean;
};

export const walletSchema: ZodType<Wallet> = z.object({
	id: z.number(),
	balance: z.number().nullable(),
	currency: z.string(),
	numberOfBets: z.number(),
	turnover: z.number(),
	cashdeskProfit: z.number(),
	isLocked: z.boolean(),
});

export type WalletDetailed = Wallet & {
	isResettable: boolean;
};

export const walletDetailedSchema: ZodType<WalletDetailed> = z.object({
	id: z.number(),
	balance: z.number().nullable(),
	currency: z.string(),
	numberOfBets: z.number(),
	turnover: z.number(),
	cashdeskProfit: z.number(),
	isLocked: z.boolean(),
	isResettable: z.boolean(),
});
